import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { createBrowserHistory } from 'history';

import { apiClient } from '../core/api/ApiClient';
import { apiClientHelper } from '../core/api/ApiClientHelper';
import { criticalErrorHandlersStorage } from 'react-redux-app/lib/modules/api/CriticalErrorHandlersStorage';
import configureStore from './configureStore';
import getApiCriticalErrorHandlers from './getApiCriticalErrorHandlers';
import routes from './routes';
import rootReducer from './reducers';
import sagas from './sagas';

import { Routes } from 'react-redux-app/lib/modules/routing/components';
import Root from './components/Root';


class App {
  constructor() {
    this.history = createBrowserHistory();

    this.reduxStore = configureStore(
      {},
      [],
      rootReducer,
      sagas,
      apiClient,
      apiClientHelper,
      this.history
    );

    criticalErrorHandlersStorage.setErrorHandlers(getApiCriticalErrorHandlers(this.reduxStore));
  }

  start() {
    createRoot(document.getElementById('rivcashAppRoot')).render(
      <Provider store={this.reduxStore} key="provider">
        <HistoryRouter history={this.history}>
          <Root>
            <Routes routes={routes} />
          </Root>
        </HistoryRouter>
      </Provider>
    );
  }
}

export default App;
